import { createReducer, on } from '@ngrx/store';

import { DocumentsActions } from './documents.actions';
import { DocumentsState } from './documents.state';

export const initDocumentsState: DocumentsState = {
  documents: [],
  documentsUpdated: [],
};
export const documentsReducer = createReducer(
  initDocumentsState,

  on(
    DocumentsActions.getDocuments,
    (): DocumentsState => ({
      ...initDocumentsState,
    })
  ),

  on(
    DocumentsActions.getDocumentsSuccess,
    DocumentsActions.dataUsageAgreementDocument.success,
    (state, { documents }): DocumentsState => ({
      ...state,
      documents,
    })
  ),

  on(
    DocumentsActions.getUpdatedDocuments,
    (state): DocumentsState => ({
      ...state,
    })
  ),

  on(
    DocumentsActions.getUpdatedDocumentsSuccess,
    (state, { updatedDocuments }): DocumentsState => ({
      ...state,
      documentsUpdated: updatedDocuments,
    })
  ),

  on(
    DocumentsActions.agreeOnDocuments,
    (state): DocumentsState => ({
      ...state,
    })
  )
);
